<template>
    <div class="author-tooltip">
        <div class="author-tooltip-title">
            <picture class="author-tooltip-logo" v-if="info.images && !noPhoto">
                <source :srcset="`${info.images.webp['size-60']} 1x, ${info.images.webp['size-120']} 2x`" type="image/webp">
                <source :srcset="`${info.images.photo['size-60']} 1x, ${info.images.photo['size-120']} 2x`" type="image/jpeg">
                <img :src="info.images.photo['size-60']" alt="logo" @error="setAltImg" loading="lazy" width="50" height="50">
            </picture>
            <div v-else-if="noPhoto" class="author-no-logo">
                <IconUser/>
            </div>
            <div v-else class="author-no-logo">
                <IconUser/>
            </div>
            <div class="author-tooltip-content">
                <div>{{ info.name || info.full_name }}</div>
                <div class="author-tooltip-details" v-if="info.country">
                    <span class="flex-v-center">
                        <CountryFlag :code="info.country.code" class="author-tooltip-country"/>
                        {{ info.country.name }}
                    </span>
                </div>
                <div class="author-tooltip-details" v-if="info.position">
                    {{ info.position }}
                </div>
                <div class="author-tooltip-experts" v-if="info.experts && info.experts.length">
                    <div class="author-tooltip-expert-label">Експерти</div>
                    <span class="author-tooltip-expert" v-for="(expert, index) in info.experts" :key="index">
                        {{ expert.name }}<span v-if="index + 1 !== info.experts.length">,</span>
                    </span>
                </div>
            </div>
            <a v-if="info.link" :href="info.link" target="_blank" class="author-tooltip-link"><IconLink/></a>
        </div>
    </div>
</template>

<script>
import CountryFlag from './CountryFlag.vue';
import IconLink from "./icons/IconLink.vue";
import IconUser from './icons/IconUser';
export default {
    name: "TestAuthorExpanded",
    props: ['info'],
    data(){
        return {
            noPhoto: false,
        }
    },
    methods: {
        setAltImg() {
            this.noPhoto = true
        },
    },
    components: {
        IconUser,
        CountryFlag, IconLink
    }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/front/helpers";

.author-tooltip {
    background: #FFFFFF;
    border-radius: 8px;
    box-shadow: 2px -2px 29px 8px rgba(160, 174, 193, 0.05), 0px 10px 20px 20px rgba(0, 0, 0, 0.04);
    width: 376px;
    padding: 18px 15px;
    font-size: 12px;

    @include responsive-below($lg) {
        width: 320px;
    }

    @include responsive-below($xs){
        width: 260px;
    }

    &-block {
        position: relative;
    }

    &-content {
        width: 100%;
        word-break: break-word;
    }

    &-title {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        font-size: 13px;
    }

    &-logo {
        width: 55px;
        min-width: 55px;
        height: 55px;

        img {
            object-fit: contain;
            object-position: top;
            height: 100%;
            border-radius: 50%;
            width: 100%;
        }
    }

    &-link {
        color: #C0C7D0;

        &:hover {
            color: #4578EB;
        }
    }

    &-details {
        margin-top: 8px;
        font-size: 12px;
        color: $text-second;
        display: flex;
        align-items: center;
        justify-content: space-between;


        svg {
            display: block;
        }
    }

    &-country {
        margin-right: 6px;
    }

    &-text {
        margin-top: 20px;
        color: $text-second;
    }

    &-expert {
        color: #252525;

        &-label {
            margin-top: 20px;
            margin-bottom: 5px;
            color: rgba(149, 149, 149, 0.7);
        }
    }
}

</style>
